import React, { useMemo } from "react";
import JobForm from "../component/JobForm";
import { parseShiftRange } from "@/utils/shiftTime";
import { toLanguageRows } from "@/utils/languageRequirements";

const Step3 = ({ data, jobFormSkills = [], onSubmit, onClose, submitRef, nextRef, onStep1CompleteChange, onConsentReadyChange, jobId, activeTab, setActiveTab, isSubmitting = false, userOptions }) => {
  // The AI returns the shift as one free-text line. Carry it into the form as
  // a custom shift so it survives to the payload — the old `shiftTiming`
  // field it used to fill is no longer sent anywhere, so a shift read out of
  // an uploaded JD was silently dropped. The time zone is left for the user:
  // a JD writes "IST", and that abbreviation is not an IANA zone name.
  const parsedShift = useMemo(() => parseShiftRange(data?.shiftTiming), [data?.shiftTiming]);

  const defaultValues = useMemo(() => ({
    jobTitle: data?.title || "",
    overview: data?.role_overview || "",
    responsibility: data?.key_responsibilities || "",
    location: data?.location || "",
    deadline: data?.deadline || "",
    // Not mandatory on the form — falls back to the same defaults as a
    // manual create when the AI extraction didn't find one.
    employeeType: data?.employeeType || "FULL_TIME",
    shiftType: parsedShift.startTime ? "custom" : "",
    shiftStartTime: parsedShift.startTime || "",
    shiftEndTime: parsedShift.endTime || "",
    shiftTimezone: "",
    vacancyCount: data?.vacancy_count || "1",
    experienceMin: data?.experience_min ?? "",
    experienceMax: data?.experience_max ?? "",
    niceToHave: data?.nice_to_have || "",
    department: data?.department || "",
    division: data?.division || "",
    companyWebsite: data?.company_website || "",
    currency: data.currency || "",
    currency_sign: data.currency_sign || "",
    linkedIn: data?.company_linkedin || "",
    certifications: Array.isArray(data?.certifications) ? data.certifications.join(", ") : "",
    // AI extraction returns plain language strings; each lands as a row
    // awaiting a proficiency pick, which the schema then requires.
    languagesRequired: toLanguageRows(data?.languages_required),
    skills: jobFormSkills,
    interviewers: data?.interviewers?.length > 0 ? data.interviewers : [{ name: "", email: "" }],
    jobPriority: data?.hiring_priority || "NORMAL",
    // No AI-generated questions — the recruiter adds them by hand in this
    // Review & Update step via the shared ApplicationQuestionsEditor.
    applicationQuestions: [],
  }), [data, jobFormSkills, parsedShift]);

  return (
    <JobForm
      key={data?.title || "empty"}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onClose={onClose}
      hideActions={true}
      submitRef={submitRef}
      nextRef={nextRef}
      onStep1CompleteChange={onStep1CompleteChange}
      onConsentReadyChange={onConsentReadyChange}
      jobId={jobId}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      isSubmitting={isSubmitting}
      userOptions={userOptions}
    />
  );
};

export default Step3;